function setBoardContent(transData, target){
	
	var token = $.getMeta('property','token');
	var target = target;
	transData['_token'] = token;
	

	$.ajax({
	  type:'POST',							
	  url: "/post/board/setContent",
	  data:transData,
	  dataType: "json",
	  success: function(res){
		  console.log("ATA : ", transData['type']);
  		switch(res.code){
	  		case 201:
	  		
	  		break;
	  		case 100:
	  			
	  			switch(transData['type']){
		  			case "guestbook":
		  				$("#guestbook-content").summernote('reset');
		  			break;
		  			case "qna":
		  				$("#qna-title").val("");
		  				$("#qna-content").summernote('reset');
		  			break;
	  			}
	  			getUserBoardContentList(transData['type'], transData['class_id'], target);
	  		break;
  		}
	}});

}

function getUserBoardContentList(type, owner_id, target){
	var page = $.GET('page');
	var transData = {
		'type' : type,
		'owner_id' : owner_id,
		'page' : page
	}

	var token = $.getMeta('property','token');
	transData['_token'] = token;

	$.ajax({
		type:'POST',
		url: "/post/board/getUserBoardContentList",
		data:transData,
		dataType: "json",
		success: function(res){
			console.log(res);
			var contentListData = res.contentListData;

			switch(res.code){
				case 100:
					createBoardListBoxes(type, contentListData, target);
					createPaginationBox(contentListData);
				break;
				case 201:

				break;
		
			}
	}});
	
}

function createBoardListBoxes(type, boxData, target){
	$(target).html("");
	$.each(boxData.data, function(idx, val){
		console.log(val);
		borderBox = createBoardBox(type, val);
		
		$(target).append(borderBox);
	});
}

function createBoardBox(type, boxData){
	var History = window.History;
	var lmsUrl = $.getMeta('property','lms');
	var timestamp = getTimestampToDate(Number(boxData.timecreated)*1000);
	
	var boardBoxHtml = '';
	boardBoxHtml += '<div class="box-board-list">';
	boardBoxHtml += '<div class="list-cover" data-board-id="32" data-title="내가 가장 좋아하는 영화 속 명장면은?">';
	boardBoxHtml += '<div class="user-info">';
	boardBoxHtml += '<div class="userImage">';
	boardBoxHtml += '<img class="img-circle" src="' + lmsUrl + '/user/pix.php/' + boxData.writer_info.id + '/f1.jpg"> ';
	boardBoxHtml += '</div>';
	boardBoxHtml += '</div>';
	boardBoxHtml += '<div class="board-info">';
	boardBoxHtml += '<div class="user-name">';
	boardBoxHtml += boxData.writer_info.firstname;
	boardBoxHtml += '</div>';
	boardBoxHtml += '<div class="board-content">';

	switch(type){
		case "qna":
			boardBoxHtml += boxData.title;
		break;
		case "guestbook":
			boardBoxHtml += boxData.content;
		break;
		
	}

	boardBoxHtml += '</div>';
	boardBoxHtml += '<div class="board-date">' + timestamp + '</div>';
	boardBoxHtml += '</div>';
	boardBoxHtml += '<div class="cr"></div>';
	boardBoxHtml += '</div>';
	boardBoxHtml += '</div>';
	
	boardBoxHtml = $.parseHTML(boardBoxHtml);
	
	$(boardBoxHtml).click(function(e){
		State = History.getState();		
		var subTitle = '';
		var modalTitle = '';
		console.log("TYPE : " + type);
		switch(type){
			case "qna":
				modalTitle = boxData.title;
				subTitle = 'Question & Answer';
			break;
			
			case "guestbook":
				modalTitle = "방명록"
				subTitle = '';			
			break;
		}
		
		var themeColor = $.getMeta('name','theme-color');
		$('#modal-userBoard').iziModal("destroy");
		
		$('#modal-userBoard').iziModal({
		    title: modalTitle,
		    subtitle: subTitle,
		    headerColor: themeColor,
		    width: 800,
		    radius: 3,
		    zindex: 1000,
		    appendTo: '.body', // or false,
		    borderBottom: 'false',
		    navigateArrows: 'closeToModal', // Boolean, 'closeToModal', 'closeScreenEdge'
		    restoreDefaultContent: true,
		    autoOpen: 0,
		    bodyOverflow: false,
		    fullscreen: true,
		    openFullscreen: false,
		    closeOnEscape: true,
		    closeButton: true,
		    overlay: true,
		    overlayClose: false,
			transitionIn: 'bounceInDown',
			transitionOut: 'bounceOutDown',
		    transitionInOverlay: 'fadeIn',
		    transitionOutOverlay: 'fadeOut',			
			history:false,
			onOpening: function(modal){
				
			 if (History.enabled) {
			      History.pushState(null, boxData.title, "?ub=" + boxData.id);
			  } else {
			      return false;
			  }				
				
				modal.startLoading();
			},
			onOpened: function(modal){
				getBoardContent(type, boxData.id, boxData, modal);
			},
			onClosed: function(modal){
				History.back();
			}
		});

		$('#modal-userBoard').iziModal('open');
	});	
	
	return boardBoxHtml;
}

function createPaginationBox(data){
	
	var paginationHTML = '';
	
	var pageEach = 3;
	var startPage = Number(data.current_page) - pageEach;
	var endPage = Number(data.current_page) + pageEach;
	
	if(startPage <= 0){
		startPage= 1;
	}
	
	if( endPage > data.last_page ){
		endPage = data.last_page;
	}
	
	if( Number(data.current_page) > pageEach +1 ){
		paginationHTML += '<li class="">';
		paginationHTML += '<a href="?page=1" >';
		paginationHTML += '<i class="fa fa-angle-double-left" aria-hidden="true"></i>';
		paginationHTML += '</a>';
		paginationHTML += '</li>';								
	}
	
	for(var page = startPage ; page >= startPage && page <= endPage ; page++ ){
		console.log(data.current_page);
		var activeClass = data.current_page == page ? 'active' : '';
		
		paginationHTML += '<li class="' + activeClass + '">';
		paginationHTML += '<a href="?page=' + page + '" >' + page + '</a>';
		paginationHTML += '</li>';
	}
	
	if( Number(data.last_page) - data.current_page > pageEach ){
		paginationHTML += '<li class="">';
		paginationHTML += ' <a href="?page=' + data.last_page + '" > ';
		paginationHTML += '<i class="fa fa-angle-double-right" aria-hidden="true"></i>';
		paginationHTML += '</a>';
		paginationHTML += '</li>';								
	}
	
	paginationHTML = $.parseHTML(paginationHTML);
	
	$("#pagination-board").html("");
	$("#pagination-board").append(paginationHTML);

}

function getBoardContent(type, type_id, boardData, modal){
	var boardData = boardData;
	var class_id = $.getMeta('name','class:id');
	var write_date = getTimestampToDate(Number(boardData.timecreated)*1000);

	$("#modal-userBoard #userBoard-write-date").html(write_date);
	$("#modal-userBoard #userBoard-writer-info").html(boardData.writer_info.firstname);
	$("#modal-userBoard #userBoard-content").html(boardData.content);
	var commentTarget = '.board-comments';
	getComments(type, type_id, commentTarget);
	
	$("#btn-add-comment").off().click(function(){
		var comment = $("#user-board-comment").val();
		setComment(null, type, type_id, comment, commentTarget);
	});
	$(".btn-del-comment").off().click(function(){
		alert("test");
	});
	$(".btn-modify-comment").off().click(function(){
		setComment();
	});	
	
	modal.stopLoading();
}

function getTimestampToDate(timestamp) {
	var date = new Date(timestamp);
	var year = date.getFullYear();
	var month = ("0"+(date.getMonth()+1)).substr(-2);
	var day = ("0"+date.getDate()).substr(-2);
	var hour = ("0"+date.getHours()).substr(-2);
	var minutes = ("0"+date.getMinutes()).substr(-2);
	var seconds = ("0"+date.getSeconds()).substr(-2);
	
	return year+"-"+month+"-"+day+" "+hour+":"+minutes+":"+seconds;
}